import React, { useState, useRef, useImperativeHandle } from 'react';
import { createPortal } from 'react-dom';
import { useFloating, FloatingArrow, arrow, useInteractions, useHover, offset, shift, flip, autoUpdate, hide, useClick, useRole, useDismiss } from '@floating-ui/react';
import styles from './Tooltip.module.scss';
import clsx from 'clsx';
export const Tooltip = ({ children, content, position, extraWide = false, className, menuClassName, title, centerText, delay = 200, customMenuComponent, disabled, clickActionEnabled = false, hoverActionEnabled = true, disableOnTouch = false, onOpenChange, ref })=>{
    const [isOpen, setIsOpen] = useState(false);
    const arrowRef = useRef(null);
    const handleOpenChange = (open)=>{
        if (disabled) return;
        setIsOpen(open);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
    };
    const forceCloseTooltip = ()=>{
        setIsOpen(false);
    };
    useImperativeHandle(ref, ()=>({
            forceCloseTooltip: forceCloseTooltip
        }));
    const option = {
        open: isOpen,
        onOpenChange: handleOpenChange,
        middleware: [
            offset(10),
            shift(),
            flip({
                fallbackAxisSideDirection: 'start'
            }),
            arrow({
                element: arrowRef
            }),
            hide()
        ],
        whileElementsMounted: autoUpdate,
        strategy: 'fixed'
    };
    if (position) option.placement = position;
    const { refs, floatingStyles, context } = useFloating(option);
    const hover = useHover(context, {
        delay: {
            open: delay,
            close: 0
        },
        enabled: hoverActionEnabled,
        mouseOnly: disableOnTouch,
        move: !disableOnTouch
    });
    const click = useClick(context, {
        enabled: clickActionEnabled
    });
    const dismiss = useDismiss(context);
    const role = useRole(context, {
        role: 'tooltip'
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover,
        click,
        dismiss,
        role
    ]);
    const renderTooltipMenu = ()=>{
        const hasCustomMenuComponent = customMenuComponent != null;
        if (hasCustomMenuComponent) {
            return /*#__PURE__*/ React.createElement("div", {
                className: clsx(styles.tooltipZIndex, menuClassName),
                ref: refs.setFloating,
                style: floatingStyles,
                ...getFloatingProps()
            }, customMenuComponent);
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.tooltipMenu, styles.tooltipZIndex, menuClassName, {
                [styles.extraWide]: extraWide
            }),
            ref: refs.setFloating,
            style: floatingStyles,
            ...getFloatingProps()
        }, /*#__PURE__*/ React.createElement(FloatingArrow, {
            className: styles.tooltipArrow,
            context: context,
            ref: arrowRef
        }), title != null && /*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.tooltipTitle, {
                [styles.center]: centerText
            })
        }, title), content != null && /*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.tooltipContent, {
                [styles.center]: centerText
            })
        }, content));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.tooltipTrigger, className),
        ref: refs.setReference,
        ...getReferenceProps()
    }, children), isOpen && /*#__PURE__*/ createPortal(renderTooltipMenu(), document.body));
};
